import { render, staticRenderFns } from "./RelatedFilterItem.vue?vue&type=template&id=1cc325c2&scoped=true"
import script from "./RelatedFilterItem.vue?vue&type=script&lang=js"
export * from "./RelatedFilterItem.vue?vue&type=script&lang=js"
import style0 from "./RelatedFilterItem.vue?vue&type=style&index=0&id=1cc325c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc325c2",
  null
  
)

export default component.exports